let loadPromise;

const SCRIPT_ID = 'google-maps-javascript-api';

const isGoogleMapsReady = () =>
  Boolean(window.google && window.google.maps && window.google.maps.importLibrary);

export const loadGoogleMapsApi = ({
  apiKey,
  libraries = ['places', 'marker'],
  version = 'weekly'
}) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.reject(new Error('Google Maps API solo puede cargarse en navegador.'));
  }

  if (!apiKey) {
    return Promise.reject(new Error('Falta REACT_APP_GOOGLE_MAPS_API_KEY.'));
  }

  if (isGoogleMapsReady()) {
    return Promise.resolve(window.google.maps);
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const callbackName = `__googleMapsInit_${Date.now()}`;
    const existingScript = document.getElementById(SCRIPT_ID);

    window[callbackName] = () => {
      delete window[callbackName];
      if (!isGoogleMapsReady()) {
        loadPromise = null;
        reject(new Error('Google Maps API no se inicializo correctamente.'));
        return;
      }
      resolve(window.google.maps);
    };

    if (existingScript) {
      existingScript.addEventListener('error', () => {
        delete window[callbackName];
        loadPromise = null;
        reject(new Error('No se pudo cargar Google Maps API.'));
      });
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      delete window[callbackName];
      loadPromise = null;
      reject(new Error('No se pudo cargar Google Maps API.'));
    };

    const params = new URLSearchParams({
      callback: callbackName,
      key: apiKey,
      loading: 'async',
      v: version
    });

    if (libraries.length > 0) {
      params.set('libraries', libraries.join(','));
    }

    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
    document.head.appendChild(script);
  });

  return loadPromise;
};
